module.exports = __webpack_public_path__ + "img/shenpi.ab9030fa.png";